import focusTrapModal from "../../../_utils/focus-trap-modal";

export default class GoogleTranslateComponent extends HTMLElement {
    private _openTranslateModalBtn: HTMLElement;
    private _closeTranslateModalBtn: HTMLElement;
    private _headerElementComponent: HTMLElement;
    private _backdrop: HTMLElement;
    private _googleTraslateModal: HTMLElement;
    constructor() {
        super();
        this._openTranslateModalBtn = this.querySelector('button.open-google-translate');
        this._closeTranslateModalBtn = this.querySelector('button.close-google-translate')
        this._headerElementComponent = document.documentElement.querySelector('header-component');
        this._backdrop = this.querySelector('button.modal-backdrop');
        this._googleTraslateModal = this.querySelector('google-translate-modal');
    }

    private mutationObserverCallback = (mutationsList: any, observer: any) => {
        const isFixedTranslateBarActive = document.documentElement.classList.contains('translated-ltr');
        if (isFixedTranslateBarActive) {
            // Reposition header when translate bar is active
            if (this._headerElementComponent) {
                this._headerElementComponent.classList.add('is-translate-bar-active');
                this.classList.remove('is-open');
            }

            const googleTranslateIframeElement: HTMLIFrameElement = document.documentElement.querySelector('iframe.goog-te-banner-frame');
            if (googleTranslateIframeElement) {
                // Hide google logo to prevent layout issue on mobile
                const iframeBody = googleTranslateIframeElement.contentWindow.document.body;
                const googleLogo: HTMLElement = iframeBody.querySelector('a.goog-logo-link');
                googleLogo.style.display = 'none';
                iframeBody.style.paddingLeft = '.5rem';
            }
        } 
        // Translation bar is not active
        else {
            if (this._headerElementComponent) {
                this._headerElementComponent.classList.remove('is-translate-bar-active');
            }
        }
    }

    private openTranslateModal: EventListener = () => {
        this.classList.add('is-open');
        document.body.addEventListener("keyup", this.handleKeypress);
        this._backdrop.addEventListener('click', this.closeTranslateModal);
        focusTrapModal(this._googleTraslateModal);
    }

    private closeTranslateModal: EventListener = () => {
        this.classList.remove('is-open');
        document.body.removeEventListener("keyup", this.handleKeypress);
        this._backdrop.removeEventListener('click', this.closeTranslateModal);
    }

    private handleKeypress = (e: KeyboardEvent) => {
        if (e instanceof KeyboardEvent) {
            if (e.key.toLowerCase() === "escape") {
                this.classList.remove('is-open');
            }
        }
    }
    connectedCallback() {
        this._openTranslateModalBtn.addEventListener('click', this.openTranslateModal);
        this._closeTranslateModalBtn.addEventListener('click', this.closeTranslateModal);

        // Apply mutation observer to documentElement to listen for google translate-bar changes
        const mutationObserver = new MutationObserver(this.mutationObserverCallback);
        mutationObserver.observe(
            document.documentElement,
            { attributes: true }
        );
    }
}